import { render, staticRenderFns } from "./digitalMarketing.vue?vue&type=template&id=27bd90f2&scoped=true&"
import script from "./digitalMarketing.vue?vue&type=script&lang=js&"
export * from "./digitalMarketing.vue?vue&type=script&lang=js&"
import style0 from "./digitalMarketing.vue?vue&type=style&index=0&id=27bd90f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd90f2",
  null
  
)

export default component.exports